import { defineStore } from "pinia"

interface PrefsState {
  theme: string
  drawerRail: boolean
}

export const usePrefsStore = defineStore("prefs", {
  state: (): PrefsState => ({
    theme: "dark",
    drawerRail: true,
  }),

  actions: {
    setTheme(theme: string) {
      this.theme = theme
    },

    setDrawerRail(drawerRail: boolean) {
      this.drawerRail = drawerRail
    },
  },

  persist: {
    key: "prefs",
    storage: localStorage,
  },
})
